import React,{useRef,useEffect,useState,useContext} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import {AppContext} from '../../../Context/AppContext'
import DateFnsUtils from '@date-io/date-fns';
import {format} from 'date-fns';
import axios from 'axios'
import {MuiPickersUtilsProvider,KeyboardDatePicker,} from '@material-ui/pickers';

import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LinearProgress from '@mui/material/LinearProgress';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import EventIcon from '@mui/icons-material/Event';
import MobileTimePicker from '@mui/lab/MobileTimePicker';

const drawerWidth = 300;

const materialTheme = createTheme(({
    // set default for now
  }));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
  fullWidth: {
    width: "100%"
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});



function ReturnInformationReview(props) {
    const classes = useStyles();
   
    const {companyId} = useContext(AppContext)
    const [requestedDeliveryDate, setRequestedDeliveryDate] = React.useState(new Date());
    const [requestedDeliveryDateCalenderOpen, setRequestedDeliveryDateCalenderOpen] = useState(false);
    const [returnedProductCondition, setReturnedProductCondition] = React.useState('good');
    const [sellerCompanyId,setSellerCompanyId] = useState('200900')
    const [isSavingTransaction,setIsSavingTransaction] = useState(false)
    const [isSavingTransactionSuccess,setIsSavingTransactionSuccess] = useState(false)
    const [showMessageDialog,setShowMessageDialog] = useState(false)
    const [messageDialogMessage,setMessageDialogMessage] = useState("")
    const [returnedProductInformations,setReturnedProductInformations] = useState(
        {
            document_number:'',
            company_id:companyId,
            company_name:'',
            returned_to_company_id:sellerCompanyId,
            returned_to_company_name:'',
            date_returned:format(new Date(), 'yyyy-MM-dd'),
            product_condition:1,
            returned_products:[]
        }
    )
    const requestedDeliveryDateHandleDateChange = (date) => {

        const returnedProductInformationsCopy = {...returnedProductInformations}
        returnedProductInformationsCopy.date_returned = format(date, 'yyyy-MM-dd')

        setRequestedDeliveryDate(date);

    };
    const documentNumberOnChange = (event)=>{

        const returnedProductInformationsCopy = {...returnedProductInformations}
        returnedProductInformationsCopy.document_number =  event.target.value
        setReturnedProductInformations(returnedProductInformationsCopy)

    }
    function getReturnedProducts(){
        const temporaryReturnedProductsString = localStorage.getItem("temporary_returned_products")
        const temporaryReturnedProducts = JSON.parse(temporaryReturnedProductsString)
        
        const returnedItems = []

        temporaryReturnedProducts.forEach((returnedProduct)=>{
            const productCode = returnedProduct.code

            returnedProduct.Units.forEach((unit)=>{
                
                if(unit.returned_quantity != null && unit.returned_quantity.length >0 && unit.returned_quantity > 0  ){
                    const returnedProductForUpload = {
                        product_code:productCode,
                        uom:unit.uom,
                        quantity:unit.returned_quantity
                      }
      
                      returnedItems.push(returnedProductForUpload)
                }
                
            })
        })

       return returnedItems

    }

    function getTotalIteReturnedCount(){
        const temporaryReturnedProductsString = localStorage.getItem("temporary_returned_products")
         if(temporaryReturnedProductsString == null){
           return 0
         }
         const temporaryReturnedProducts = JSON.parse(temporaryReturnedProductsString)
    
         const totalOrderedItems = temporaryReturnedProducts.reduce((productWithReturnedPartialCount,product)=>{
           return productWithReturnedPartialCount + product.Units.reduce((partialCount,unit)=>partialCount + (unit.returned_quantity > 0 ? 1 : 0),0)
         },0)
         
         return totalOrderedItems
         
      }
    function computeOverallTotalReturnedAmount(){
        const temporaryReturnedProductsString = localStorage.getItem("temporary_returned_products")
         if(temporaryReturnedProductsString == null){
           return 0
         }
         const temporaryReturnedProducts = JSON.parse(temporaryReturnedProductsString)
         const overallTotalAmount = temporaryReturnedProducts.reduce((partialSum,product)=>partialSum + computeTotalReturnedAmountPerProduct(product),0.00).toFixed(2)
         
         return overallTotalAmount
         
      }  
    function computeTotalReturnedAmountPerProduct(product){
        const totalInvoiceValue = Number(product.Units.reduce((partialSum,unit)=> 
          {
            const amount = parseFloat(unit.returned_quantity) * unit.price_with_tax
            return partialSum + (isNaN(amount) ? 0 : amount)
  
          },0.00 ))
        return isNaN(totalInvoiceValue) ? 0 : totalInvoiceValue
    }  

    const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
     
        if(key == 'returned_products'){
         object[key].forEach((order)=>{
     
              formData.append(key,JSON.stringify(object[key])) 
         })
 
        }else{
         formData.append(key, object[key]);
       }
     
     return formData;
   }, new FormData());

 
    function saveReturnedProducts(){

        const returnedProductInformationsCopy = {...returnedProductInformations}
        returnedProductInformationsCopy.returned_products =  getReturnedProducts()

        setIsSavingTransaction(true)

        const options = {
            method: 'POST',
            url: '/TransactiLiteReturnedProductInformations/save.json',
            data:objectToFormData(returnedProductInformationsCopy)
          }
           axios(options)
             .then(res => {
                
              
              setIsSavingTransaction(false)
              const isSuccess = res.data.response.is_success
              if(!isSuccess){
                 setIsSavingTransactionSuccess(false)
                 setIsSavingTransaction(false)
                 setMessageDialogMessage(res.data.response.message)
                 setShowMessageDialog(true)
    
                return;
              }
              
               localStorage.removeItem("temporary_returned_products")
    
               setIsSavingTransactionSuccess(true)
               setIsSavingTransaction(false)
               setMessageDialogMessage(res.data.response.message)
               setShowMessageDialog(true)
    
            
              
              
             }).catch(error => {
      
                setIsSavingTransactionSuccess(false)
                setIsSavingTransaction(false)
                setMessageDialogMessage("Failed to save invoice. Please try again.")
                setShowMessageDialog(true)
     
               
      
             })




      
    }


    function progressDialog(){
        return(
          <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          open={isSavingTransaction}
          onClose={()=>{}}
        >
         
          <DialogContent>
            <DialogContentText>
              Saving returned... Please wait...
            </DialogContentText>
            <LinearProgress color="secondary" />
          </DialogContent>
        </Dialog>
        )
    }

    function messageDialog(){
        return(
          <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={showMessageDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
             {messageDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{
  
                setShowMessageDialog(false)
                if(isSavingTransactionSuccess == true){
                 props.closeAllDialog()
                }
                
                
                }} 
              color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        )
    }

    return (
        <div>
           <Dialog fullScreen open={props.openReturnInformationReview} onClose={()=>{props.setOpenReturnInformationReview(false)}} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={()=>{props.setOpenReturnInformationReview(false)}}
                        aria-label="close"
                        size="large">
                    <CloseIcon />
                    </IconButton>
                    <Typography variant="subtitle1" className={classes.title}>
                        Return Information Review
                    </Typography>
                </Toolbar>
            </AppBar>
            <div className={classes.appBarSpacer}></div>
            <div style={{padding:'.5rem'}}>
            <Grid container spacing={1}>
                <Grid item xs={12} >Document Number*</Grid>
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                            <TextField
                                className={classes.fullWidth}
                                id="contact-name"
                                rows={4}
                                variant="outlined"
                                onChange={documentNumberOnChange}
                            />
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Grid>

                <Grid item xs={12} >Products Returned Date*</Grid>
                <Grid item xs={12}>
                  <StyledEngineProvider injectFirst>
                          <ThemeProvider theme={materialTheme}>
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                  <MobileDatePicker
                                
                                  inputFormat="MMMM d, yyyy"
                                  format="MMMM d, yyyy"
                                  InputProps={{ readOnly: true }}
                                  onClick={() => setRequestedDeliveryDateCalenderOpen(true)}
                                  value={requestedDeliveryDate}
                                  open={requestedDeliveryDateCalenderOpen}
                                  onOpen={() => setRequestedDeliveryDateCalenderOpen(true)}
                                  onClose={() => setRequestedDeliveryDateCalenderOpen(false)}
                                  onChange={requestedDeliveryDateHandleDateChange}
                                  renderInput={(params) => 
                                      <TextField 
                                          {...params} 
                                          className={classes.fullWidth} 
                                          InputProps={{
                                              endAdornment: (
                                                <InputAdornment position="end">
                                                  <IconButton edge="end" onClick={()=>{setRequestedDeliveryDateCalenderOpen(true)}}>
                                                    <EventIcon />
                                                  </IconButton>
                                                </InputAdornment>
                                              ),
                                            }}
                                          />
                                      }
                                  />
                              </LocalizationProvider>
                          </ThemeProvider>
                      </StyledEngineProvider>  
                </Grid>

                <Grid item xs={12} >Return Product Condition*</Grid>
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                        <Select
                         className={classes.fullWidth}
                            variant="outlined"
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            value={returnedProductInformations.product_condition}
                            onChange={(event)=>{
                                const returnedProductInformationsCopy = {...returnedProductInformations}
                                returnedProductInformationsCopy.product_condition = event.target.value
                                setReturnedProductInformations(returnedProductInformationsCopy)
                            }}
                            >
                        
                        <MenuItem value={1}>Good</MenuItem>
                        <MenuItem value={0}>Bad</MenuItem>
                        </Select>
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Grid>
                
                    <Grid item xs={12} >Number of lines : <span style={{fontSize:'1rem'}}>{getTotalIteReturnedCount()}</span> </Grid>
                    <Grid item xs={12} >Value : <span style={{fontSize:'1rem'}}>{computeOverallTotalReturnedAmount()}</span> </Grid>
                
                <Grid item container >
                <Button variant="contained" color="primary" style={{width:"100%"}} onClick={()=>{
                    
                        saveReturnedProducts()

                        //props.closeAllDialog()
                    
                    }}>
                    Finalize Products Returned
                </Button>
                </Grid>
            </Grid>
            </div>
      </Dialog>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
               {progressDialog()}
               {messageDialog()}
               </ThemeProvider>
            </StyledEngineProvider>
           
        </div>
    );
}

export default ReturnInformationReview